export default "__VITE_ASSET__BV_fT$KD__"